import { Button, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles(() => ({
  button: (form) => ({
    height: form && 46,
    textTransform: "none",
  }),
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
    borderRadius: 10,
  }
}));

/** 
 * Define button for general use
 * 
 * @param {node} children - content of the button
 * @param {string} className - override or extend styles of component 
 * @param {boolean} form - purpose
 * @param {string} variant - purpose
 * @param {function} onSubmit - purpose
 * @param {boolean} loading - purpose
 * @param {boolean} disabled - purpose
 * 
 * @return {Button component}
 */
function TraxxButton({
  children,
  className,
  color = "primary",
  form,
  variant,
  onSubmit,
  loading,
  disabled,
  ...props
}) {
  const classes = useStyles(form);
  return (
    <Button
      className={clsx(classes.button, className)}
      color={color}
      variant={variant}
      {...props}
      onClick={onSubmit}
      disabled={!!loading || disabled}>

      {children}

      {loading && (
        <CircularProgress className={classes.buttonProgress} value={24} size={24} />
      )}
    </Button>
  );
}

export default TraxxButton;

TraxxButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  form: PropTypes.bool,
  variant: PropTypes.string,
};

TraxxButton.defaultProps = {
  className: "",
  form: false,
  variant: "contained",
};
